import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import Treemap from "highcharts/modules/treemap";
import Heatmap from "highcharts/modules/heatmap";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { Segments, VolumeSegmentsOptions, weeklyDataValue } from "../../utlits";
import { sortingMethod } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import { addDays, getDiffBtnDates } from "../../../../utils/dateCalculater";
import NoDataFound from "../../generic/NoDataFound";
Treemap(Highcharts);
Heatmap(Highcharts);

export interface IVS_HeatMapChartProps {
  rowHeatmapData: any;
  handleDownloadBtn: () => void;
}

const VS_HeatMapChart: React.FC<IVS_HeatMapChartProps> = (props) => {
  const [segmentDropdownValue, setSegmentDropdownValue] =
    React.useState<string>(Segments.Currency);

  const [heatmapData, setHeatmapData] = useState<any>([]);
  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  const setUpChart = async (sortedData: any) => {
    if (sortedData.length > weeklyDataValue) {
      let firstDate = sortedData ? sortedData[0].key : "";
      let lastDate = sortedData ? sortedData[sortedData.length - 1].key : "";
      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = Math.floor(totalWeeks) + 1;
      }

      let value: Array<any> = [];
      let getNtHitsPrDay = [...sortedData];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        // Get first Date and adding seven days of getNtHitsPrDay array
        let seventhDay = await addDays(dateOne, 6);

        // eslint-disable-next-line no-loop-func
        let customData = getNtHitsPrDay.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customData.length > 0) {
          let totalVal: any = 0;
          for (let j = 0; j < customData.length; j++) {
            totalVal += parseInt(customData[j].val);
          }
          if (lastDate < moment(seventhDay).format("YYYY-MM-DD")) {
            value.push({
              name: `${moment(dateOne).format("DD MMM")} - ${moment(
                lastDate
              ).format("DD MMM")}`,
              value: parseInt(totalVal),
              colorValue: parseInt(totalVal),
            });
          } else {
            value.push({
              name: `${moment(dateOne).format("DD MMM")} - ${moment(
                seventhDay
              ).format("DD MMM")}`,
              value: parseInt(totalVal),
              colorValue: parseInt(totalVal),
            });
          }
        } else {
          if (lastDate < moment(seventhDay).format("YYYY-MM-DD")) {
            value.push({
              name: `${moment(dateOne).format("DD MMM")} - ${moment(
                lastDate
              ).format("DD MMM")}`,
              value: 0,
              colorValue: 0,
            });
          } else {
            value.push({
              name: `${moment(dateOne).format("DD MMM")} - ${moment(
                seventhDay
              ).format("DD MMM")}`,
              value: 0,
              colorValue: 0,
            });
          }
        }

        dateOne = await addDays(seventhDay, 1);
      }

      if (value.length > 0) {
        setHeatmapData([...value]);
      }
    } else {
      let value: any = [];
      sortedData.forEach((api: any) => {
        value.push({
          name: moment(api.key).format("DD MMM"),
          value: parseInt(api.val),
          colorValue: parseInt(api.val),
        });
      });
      if (value.length > 0) {
        setHeatmapData([...value]);
      }
    }
  };

  useEffect(() => {
    console.log("props.rowHeatmapData", props.rowHeatmapData);
    if (props.rowHeatmapData.length > 0) {
      setDisableMenu(false);
      let segmentwiseData = props.rowHeatmapData.filter((segData: any) => {
        return segData.seg === segmentDropdownValue;
      });
      if (segmentwiseData.length > 0) {
        let sortedData = sortingMethod(segmentwiseData[0]?.vol);
        setUpChart(sortedData);
      }
    } else {
      setDisableMenu(true);
      setHeatmapData([]);
    }
  }, [props.rowHeatmapData, segmentDropdownValue]);

  const options = {
    chart: {
      type: "treemap",
      height: "300px",
    },
    title: "",
    credits: {
      enabled: false,
    },
    legend: false,
    colorAxis: {
      minColor: "#d9e9ff",
      maxColor: "#001f4a",
      startOnTick: false,
      endOnTick: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          type: "dateTime",
          format: "{point.value},{point.name}",
          // formatter: function (this: any): any {
          //   console.log("this.point", this.point);
          //   return `<div>${this.point.value}, ${this.point.name}</div>`;
          // },
          color: "white",
          verticalAlign: "top",
          style: {
            textOutline: false,
          },
        },
      },
    },

    series: [
      {
        layoutAlgorithm: "squarified",
        data: heatmapData ? heatmapData : [],
        reversedStacks: true,
      },
    ],
  };
  return (
    <>
      <ColoumnsHeader
        title={"Volume Heatmap"}
        isDownload={true}
        isDropdown={true}
        dropdownOptions={VolumeSegmentsOptions}
        dropdownValue={segmentDropdownValue}
        setDropdownValue={setSegmentDropdownValue}
        isMidleBorder={true}
        disableMenu={disableMenu}
        handleDownloadBtn={props.handleDownloadBtn}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <div className="highcharts-figure">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      )}
    </>
  );
};

export default VS_HeatMapChart;
